const odsOfferLanguage = (offerVal, odsType) => {
  if (typeof offerVal === 'string' && Number.isNaN(parseFloat(offerVal))) {
    return offerVal
  }

  let response = ''

  if (offerVal <= 0.7 && odsType === 'Card') {
    response = 'You have an excellent chance of getting an Avant Card!'
  } else {
    let language = 'pre-selected'

    if (offerVal > 0.9) language = 'pre-approved'
    else if (offerVal > 0.8) language = 'pre-qualified'

    response =
      odsType === 'Card'
        ? `You're ${language} for an Avant Card!`
        : `You're ${language} for a loan through Avant!`
  }
  return response
}

export default odsOfferLanguage
